import { ToastContainer as ToastifyContainer } from "react-toastify";

import { useBreakpoint } from "@seneca/senekit";

import CloseButton from "./CloseButton";

export default function ToastContainer() {
  const { isMobileOnly } = useBreakpoint();

  return (
    <ToastifyContainer
      closeButton={<CloseButton />}
      style={{ width: isMobileOnly ? "100vw" : "400px" }}
    />
  );
}
